import { RefObject } from "react";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import IBaseDTO from "src/Interfaces/baseDTO";


export interface IEftbs004 extends IBaseDTO{
 efs004Id: number;
 efs004Efa002Id: number;
 efs004Key: string; 
 efs004Efa005Id: number; 
 efs004Datahora: string | Date; 
 efs004Situacao: IEfs004Situacao; 
 efs004Dthrlimite: string | Date;  
 efs004Efa005Id2: number; 
 efs004Dthracesso: string | Date;  
 efs004Efs001Id: number; 
}

export enum IEfs004Situacao {
  GENERATED = 1,
  IN_USE = 2,
  FINISHED = 3,
  EXPIRED = 4
}

export interface IRefModalExternalAccessKeys {
  actionButtonAdd: () => void;
  actionButtonDelete: (row: IEftbs004) => void;
}

export interface IComponentModalExternalAccessKeys {
  paginationRef: RefObject<IForwardPagination>
}
